import useInView from '@propertypal/shared/src/hooks/useInView';
import { Property } from '@propertypal/shared/src/types/property';
import React, { FunctionComponent, useRef } from 'react';
import { Text } from '../typography';
import PropertyBox from './PropertyBox';
import PropertyPlaceholder from './PropertyPlaceholder';
import { Container, Content, LoadingBox, Rail, Title } from './SimilarProperties.style';

interface Props {
  properties?: Property[];
  onInView?: () => void;
  title?: string;
  emptyText?: string;
  background?: string;
  imageLocator?: string;
  onFavourite?: () => (favourited: boolean, propertyId: number) => Promise<boolean>;
  hideOnEmpty?: boolean;
}

const SimilarProperties: FunctionComponent<Props> = (props) => {
  const container = useRef<HTMLDivElement>(null);
  useInView(props.onInView, container, props.properties);

  if (props.hideOnEmpty && (!props.properties || props.properties.length === 0)) {
    return null;
  }

  if (!props.properties || (props.properties.length === 0 && props.emptyText)) {
    return (
      <Container className="pp-similar-properties" ref={container} background={props.background}>
        <LoadingBox>
          {!!props.title && (
            <Title className="pp-similar-properties-title" style={{ marginLeft: 0 }}>
              {props.title}
            </Title>
          )}

          {!props.properties && (
            <Rail>
              <PropertyPlaceholder />
              <PropertyPlaceholder />
              <PropertyPlaceholder />
            </Rail>
          )}

          {props.properties?.length === 0 && props.emptyText && <Text mt={15}>{props.emptyText}</Text>}
        </LoadingBox>
      </Container>
    );
  }

  if (props.properties && props.properties.length > 0) {
    return (
      <Container className="pp-similar-properties" data-testid="similarProperties" background={props.background}>
        <Content>
          {!!props.title && <Title className="pp-similar-properties-title">{props.title}</Title>}

          <Rail>
            {props.properties.map((property) => (
              <PropertyBox
                key={property.id}
                property={property}
                hideFooter
                imageLocator={props.imageLocator}
                onFavourite={props.onFavourite}
              />
            ))}
          </Rail>
        </Content>
      </Container>
    );
  }

  return null;
};

export default SimilarProperties;
